import { ProjectProcess } from '@work4all/models/lib/Classes/ProjectProcess.entity';
import { ProjectProcessKind } from '@work4all/models/lib/Enums/ProjectProcessKind.enum';

export const RESOURCE_PROJECT_ID_PRFX = 'project-';

export const getNearestParentProcess = (
  processList: ProjectProcess[],
  fromIdx: number
) => {
  if (!processList || processList.length === 0) {
    return null;
  }
  for (let i = fromIdx - 1; i >= 0; i--) {
    const process = processList[i];
    if (process?.kindId === ProjectProcessKind.GLIEDERUNGSPUNKT) {
      return process;
    }
    return null;
  }
};
